import { useEffect } from 'react'
import { useLocalStorage } from "@uidotdev/usehooks"
import isEqual from 'lodash/isEqual'

const useQaDocumentStatuses = (props) => {
    const cacheMinutes = 60
    const [lastUpdated, setLastUpdated] = useLocalStorage('qa_document_statuses_last_updated', 0)
    const [qaDocumentStatuses, setQaDocumentStatuses] = useLocalStorage('qa_document_statuses', [])
    const [qaDocumentAreas, setQaDocumentAreas] = useLocalStorage('qa_document_areas', [])
    const [qaDocumentTypes, setQaDocumentTypes] = useLocalStorage('qa_document_types', [])

    
    useEffect(() => {
        if (qaDocumentStatuses.length === 0 || qaDocumentAreas.length === 0 || qaDocumentTypes.length === 0) {
            reloadQaDocumentStatuses()
            return
        }
        if( lastUpdated + (1000 * 60 * cacheMinutes) > Date.now() ) {
            return
        }
        reloadQaDocumentStatuses()
    }, [])

    const reloadQaDocumentStatuses = () => {
        setLastUpdated(Date.now())
        fetch('/v0/qa_document_statuses', { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                if( ! isEqual(json.results, qaDocumentStatuses) ) {
                    setQaDocumentStatuses(json.results)
                }
            })
            .catch(error => {
                console.log("QADocumentStatuses reload error", error)
            })
        
        fetch('/v0/qa_document_types', { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                if( ! isEqual(json.results, qaDocumentTypes) ) {
                    setQaDocumentTypes(json.results)
                }
            })
            .catch(error => {
                console.log("QADocumentTypes reload error", error)
            })
        
        fetch('/v0/qa_document_areas', { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                if( ! isEqual(json.results, qaDocumentAreas) ) {
                    setQaDocumentAreas(json.results)
                }
            })
            .catch(error => {
                console.log("QADocumentAreas reload error", error)
            })
    }

    return {
        qaDocumentStatuses,
        qaDocumentAreas,
        qaDocumentTypes,
        reloadQaDocumentStatuses,
    }
}

export default useQaDocumentStatuses
